
































import defaultComponent from "../utils/defaultComponent";
export default defaultComponent.apply({
  props: [],
  data() {
    return {
      collapse: false,
      drawer: false,
    };
  },
  methods: {
    initialize() {
    }
  },
  extraOptions: {
    defaultClass: "navMenu"
  }
});
